import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "payments"
const PaymentsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M10.5 7.125C12.364 7.125 13.875 8.636 13.875 10.5S12.364 13.875 10.5 13.875 7.125 12.364 7.125 10.5 8.636 7.125 10.5 7.125M10.5 8.625C9.464 8.625 8.625 9.465 8.625 10.5S9.465 12.375 10.5 12.375 12.375 11.535 12.375 10.5 11.535 8.625 10.5 8.625"
            clipRule="evenodd"
          />
          <path d="M5.25 9.75C5.664 9.75 6 10.086 6 10.5S5.664 11.25 5.25 11.25 4.5 10.914 4.5 10.5 4.836 9.75 5.25 9.75M15.75 9.75C16.164 9.75 16.5 10.086 16.5 10.5S16.164 11.25 15.75 11.25 15 10.914 15 10.5 15.336 9.75 15.75 9.75" />
          <path
            fillRule="evenodd"
            d="M18 3.75C18.828 3.75 19.5 4.422 19.5 5.25V6.75H21C21.828 6.75 22.5 7.422 22.5 8.25V18.75C22.5 19.578 21.828 20.25 21 20.25H6C5.172 20.25 4.5 19.578 4.5 18.75V17.25H3C2.172 17.25 1.5 16.578 1.5 15.75V5.25C1.5 4.422 2.172 3.75 3 3.75zM19.5 15.75C19.5 16.578 18.828 17.25 18 17.25H6V18.75H21V8.25H19.5zM3 15.75H18V5.25H3z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PaymentsIcon
